<template>
  <div class="figure_box">
    <div class="label_class">
      {{ label }}
    </div>
    <div class="val__class" :class="color ? color_class : 'normal_val_color'">
      <span v-if="val_string">{{ val_string }}</span>
      <span v-else>{{ val | addCommaDecimal }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "SummaryFigure",
  props: {
    label: {
      default: "",
      type: String,
    },
    val: {
      default: 0,
      type: Number,
    },
    val_string: {
      default: null,
    },
    color: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    color_class() {
      if (this.val >= 0) {
        return "positive_color";
      } else {
        return "negative_color";
      }
    },
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.figure_box {
  border-radius: 8px;
  background: #f5f5f5;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 80px;
}
.label_class {
  color: #757575;

  font-family: Avenir;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.val__class {
  font-family: Avenir;
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.normal_val_color {
  color: var(--Button-Black, #283037);
}
.positive_color {
  color: var(--Green-2, #27ae60);
}
.negative_color {
  color: var(--Red, #eb5757);
}
</style>
